// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"2a6d0f948dc379e2c5d5","491":"7b2c1af3be265f8bc985","691":"b988dd91d0a073ddb7bb"}[chunkId] + ".js";
};